import React, { Component } from "react";
import { connect } from "react-redux";
import { emailLogin, logout } from "../actions/userAction";
import {
  getorderdetails,
  // MD_Order_Status,
  // allstorename,
} from "../actions/assetActionOrderHistory";
import { Link } from "react-router-dom";
import {
  Icon,
  Tooltip,
  Button,
  Input,
  Tag,
  Col,
  Row,
  Table,
  Divider,
  message,
  DatePicker,
  Form,
  notification,
  Modal,
  Select,
} from "antd";
import "../styles/css/App.css";
import Highlighter from "react-highlight-words";
import { TimeAgo } from "@n1ru4l/react-time-ago";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import _ from "lodash";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { db } from "../firebase";
import firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";
import UIfx from "uifx";
const tick = new UIfx(
  "https://storage.googleapis.com/shopezy-a4bc4.appspot.com/Audio/there-you-go.mp3"
);
const { Option } = Select;
const cryptLib = require("@skavinvarnan/cryptlib");
const openNotificationWithIcon = () => {
  notification["success"]({
    message: "New Order Placed",
    duration: 5,
  });
};
class Order extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    const from_date = today.startOf("day").format();
    const to_date = today.endOf("end").format();
    // state
    this.state = {
      disabled: true,
      searchText: "",
      tdata: null,
      loading: true,
      startValue: null,
      endValue: null,
      endOpen: false,
      visible: false,
      volume: 0,
      mvisible: false,
      iconLoading: false,
      startdate: from_date,
      enddate: to_date,
      is_date: true,
      is_displayorderid: false,
      is_phonenumber: false,
    };
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{
            width: 188,
            marginBottom: 8,
            display: "block",
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{
            width: 90,
            marginRight: 8,
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{
            width: 90,
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon
        type="search"
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{
          backgroundColor: "#ffc069",
          padding: 0,
        }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
    console.log(this.state.searchText);
  };
  componentDidMount() {
    this.setState({
      loading: false,
      visible: true,
    });
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.common !== nextProps.common) {
      if (parseInt(this.props.common) !== 0) {
        console.log("will receive");
        tick.setVolume(this.state.volume).play();
        if (this.state.volume === 1) {
          openNotificationWithIcon();
        }
      }
    }
  }
  handleResett = () => {
    this.props.form.resetFields();
    // this.setState({orderStatus: []})//empty
    const initialDate = new Date();
    const today = moment();
    const from_date = today.startOf("day").format();
    const to_date = today.endOf("end").format();
    this.setState({ loading: true });
    this.props
      .getorderdetails(from_date, to_date)
      .then((res) => {
        console.log(res);
        this.setState({
          tdata: this.props.order,
          loading: false,
          date: initialDate,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  };
  renderNotes() {
    return _.map(this.props.order, (order, key) => {
      return (
        <tr key={key}>
          <td>{order.cust_id}</td>
          <td>{order.order_id}</td>
          <td>{order.customer_name}</td>
          <td>{order.customer_phone}</td>
          <td>{order.delivery_address}</td>
          <td>{order.driver_name}</td>
          <td>{order.store_name}</td>
          <td>{order.order_status}</td>
          <td>{order.Total_Price}</td>
          <td>{order.Payment_Type}</td>
          <td>{order.orderno}</td>
          <td>{order.Order_Coupon_Applicable === true ? "Yes" : "No"}</td>
          <td>{order.order_date}</td>
        </tr>
      );
    });
  }
  confirmdelete = (key) => {
    const initialDate = new Date();
    this.setState({ loading: true });
    //console.log(key);
    db.collection("Order")
      .doc(key)
      .update({
        Ref_Driver_Id: "",
        Ref_Driver_Name: "",
        Ref_Order_Status_Id: 5,
        Driver_Accepted_Address: "",
        Driver_Accepted_Latitude: 0,
        Driver_Accepted_Longitude: 0,
        Updated_At: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((res) => {
        this.props
          .dashreporttoday()
          .then((result) => {
            console.log("resolved", this.props.dashtoday);
            this.setState({ dashstats: this.props.dashtoday });
          })
          .catch((error) => {
            console.log("error");
            this.setState({ loading: false });
          });
        this.props
          .allorder()
          .then((res) => {
            console.log(res);
            this.setState({
              tdata: this.props.order,
              loading: false,
              date: initialDate,
            });
            message.success("Order successfully updated!");
          })
          .catch((error) => {
            console.log(error);
            this.setState({ loading: false });
          });
      })
      .catch((error) => {
        message.error("Error removing document: ", error);
        this.setState({ loading: false });
      });
  };
  disabledStartDate = (startValue) => {
    return startValue && startValue > moment().endOf("day");
  };
  disabledEndDate = (endValue) => {
    return endValue && endValue > moment().endOf("day");
  };
  onChange = (field, value) => {
    this.setState({ [field]: value });
  };
  onStartChange = (value) => {
    this.onChange("startValue", value);
  };
  onEndChange = (value) => {
    this.onChange("endValue", value);
  };
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };
  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  };
  handlefilterbyOnChange = (value) => {
    if (value === "Date") {
      this.setState({
        is_date: true,
        is_displayorderid: false,
        is_phonenumber: false,
      });
    } else if (value === "Order_ID") {
      this.setState({
        is_date: false,
        is_displayorderid: true,
        is_phonenumber: false,
      });
    } else if (value === "Phone_Number") {
      this.setState({
        is_date: false,
        is_displayorderid: false,
        is_phonenumber: true,
      });
    } else {
      console.log("invalid filter type", value);
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["start_date", "end_date", "display_orderid", "phone_number"],
      (err, values) => {
        if (!err) {
          const start_date = values.start_date;
          const end_date = values.end_date;
          const display_orderid = values.display_orderid;
          const phone_number = values.phone_number;
          console.log(values);
          // if (start_date && end_date) {
          //     message.error('date'+start_date, end_date);
          // } else if (display_orderid) {
          //     message.error("display_orderid",display_orderid)
          // }
          // else {
          this.setState({ loading: true });
          console.log(values);
          this.props
            .getorderdetails(
              start_date,
              end_date,
              display_orderid,
              phone_number
            )
            .then((res) => {
              console.log(res);
              this.setState({
                tdata: this.props.order,
                loading: false,
                visible: true,
              });
            })
            .catch((error) => {
              console.log("error", error.message);
              this.setState({ loading: false });
            });
          // }
        }
      }
    );
  };
  editorder = (e) => {
    console.log(e);
    this.props.form.setFieldsValue({
      order_id: e.order_id,
      Order_Status: e.orderstatus_id,
      otp: e.OTP_Num,
      order_key: e.key,
      store_id: e.store_id,
    });
    this.setState({
      mvisible: true,
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      mvisible: false,
    });
  };
  handleCancel = (e) => {
    console.log(e);
    this.setState({
      mvisible: false,
    });
  };
  handleSubmit1 = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["order_id", "Order_Status", "otp", "order_key", "store_id"],
      (err, values) => {
        if (!err) {
          this.setState({ iconLoading: true });
          const key = "bbC2H19lkVbQDfakxcrtNMQdd0FloLyw";
          const OTP_Num = cryptLib.encryptPlainTextWithRandomIV(
            values.otp,
            key
          );
          var obj = {
            Display_Order_Id: values.order_id,
            Order_OTP: OTP_Num,
            Ref_Order_Store_Id: values.store_id,
            Updated_At: firebase.firestore.FieldValue.serverTimestamp(),
          };
          db.collection("Order")
            .doc(values.order_key)
            .update(obj)
            .then((res) => {
              console.log(res);
              this.setState({
                loading: true,
                mvisible: false,
                iconLoading: false,
              });
              const today = moment();
              const from_date = today.startOf("day").format();
              const to_date = today.endOf("end").format();
              var arr_orderstatus = this.state.orderStatus;
              this.props
                .getorderdetails(from_date, to_date, arr_orderstatus)
                .then((res) => {
                  console.log(res);
                  this.setState({ tdata: this.props.order, loading: false });
                })
                .catch((error) => {
                  console.log("error");
                  this.setState({ loading: false });
                });
            });
        }
      }
    );
  };
  renderStorename() {
    return _.map(this.props.storeall, (storeall, key) => {
      return (
        <Option value={storeall.key} key={key}>
          {storeall.store_name}
        </Option>
      );
    });
  }
  handleStoreID = (value) => {
    this.setState({ StoreID: value });
  };
  copyCodeToClipboard = (e) => {
    console.log(e);
    this.setState({ copytext: e });
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
  };
  //===============================================
  //===============================================
  render() {
    const { endOpen } = this.state;
    const { getFieldDecorator } = this.props.form;
    const columns = [
      {
        title: "Order ID",
        dataIndex: "order_id",
        width: 140,
        key: "order_id",
        ...this.getColumnSearchProps("order_id"),
      },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        width: 120,
        key: "customer_name",
        ...this.getColumnSearchProps("customer_name"),
      },
      {
        title: "Customer Phone",
        dataIndex: "customer_phone",
        width: 120,
        key: "customer_phone",
        ...this.getColumnSearchProps("customer_phone"),
      },
      {
        title: "Delivery Address",
        dataIndex: "delivery_address",
        width: 150,
        key: "delivery_address",
        ...this.getColumnSearchProps("delivery_address"),
      },
      {
        title: "Store Name",
        dataIndex: "store_name",
        key: "store_name",
        width: 120,
      },
      {
        title: "Driver Name",
        dataIndex: "driver_name",
        width: 120,
        key: "driver_name",
        ...this.getColumnSearchProps("driver_name"),
      },
      {
        title: "Order Status",
        dataIndex: "order_status",
        width: 130,
        key: "order_status",
        render: (text, record) => (
          <span>
            {(() => {
              switch (record.orderstatus_id) {
                case 7:
                  return <Tag color="lime">{record.order_status}</Tag>;
                case 12:
                  return <Tag color="#87d068">{record.order_status}</Tag>;
                case 9:
                  return <Tag color="volcano">{record.order_status}</Tag>;
                default:
                  return <Tag color="orange">{record.order_status}</Tag>;
              }
            })()}
          </span>
        ),
      },
      {
        title: "Payment Type",
        dataIndex: "Payment_Type",
        key: "Payment_Type",
        width: 80,
      },
      {
        title: "Price",
        dataIndex: "Total_Price",
        key: "Total_Price",
        width: 130,
        ...this.getColumnSearchProps("Total_Price"),
      },
      {
        title: "OTP",
        dataIndex: "OTP_Num",
        key: "OTP_Num",
        width: 80,
      },
      {
        title: "Order Date",
        dataIndex: "order_date",
        width: 190,
        key: "order_date",
      },
      {
        title: "No. of Order",
        dataIndex: "orderno",
        width: 80,
        key: "orderno",
      },
      {
        title: "App Version",
        dataIndex: "App_version",
        key: "App_version",
        width: 150,
        ...this.getColumnSearchProps("App_version"),
      },
      {
        title: "Coupon Applied",
        dataIndex: "Order_Coupon_Applicable",
        width: 150,
        key: "Order_Coupon_Applicable",
        render: (text, record) => (
          <span>
            {record.Order_Coupon_Applicable === true ? (
              <Tag color="green">Yes</Tag>
            ) : (
              <Tag color="volcano">No</Tag>
            )}
          </span>
        ),
      },
      {
        title: "Order Device",
        dataIndex: "Order_Request_Device",
        key: "Order_Request_Device",
        width: 150,
        ...this.getColumnSearchProps("Order_Request_Device"),
      },
      {
        title: "Customer Id",
        dataIndex: "cust_id",
        key: "cust_id",
        ...this.getColumnSearchProps("cust_id"),
      },
      {
        title: "Action",
        dataIndex: "action",
        fixed: "right",
        width: 250,
        key: "action",
        render: (text, record) => (
          <span>
            {record.orderstatus_id === 10 ? (
              <span>
                <Tooltip title="Copy Order">
                  <CopyToClipboard
                    onCopy={this.onCopy}
                    text={record.customerdetail}
                  >
                    <Button type="primary" shape="circle" icon="copy" />
                  </CopyToClipboard>
                </Tooltip>
                <Divider type="vertical" />
                <Tooltip title="Edit Order">
                  <Button
                    type="primary"
                    shape="circle"
                    onClick={() => this.editorder(record)}
                    icon="edit"
                  />
                </Tooltip>
                <Divider type="vertical" />
                <Link
                  to={{
                    pathname: "/trackorder",
                    orderid: record.key,
                  }}
                >
                  <Tooltip title="Order Tracking">
                    <Button type="primary" shape="circle" icon="environment" />
                  </Tooltip>
                </Link>
                <Divider type="vertical" />
                <Link
                  target="_blank"
                  to={{
                    pathname: "/orderview?id=" + record.key,
                  }}
                >
                  <Tooltip title="View Order ">
                    <Button type="primary" shape="circle" icon="eye" />
                  </Tooltip>
                </Link>
                <Divider type="vertical" />
                <Tooltip title="Revoke Driver">
                  <Button
                    type="primary"
                    shape="circle"
                    onClick={() => this.confirmdelete(record.key)}
                    disabled={
                      record.orderstatus_id === 7 ||
                      record.orderstatus_id === 5 ||
                      record.orderstatus_id === 17 ||
                      record.orderstatus_id === 9
                        ? false
                        : true
                    }
                    icon="user"
                  />
                </Tooltip>
              </span>
            ) : (
              <span>
                <Tooltip title="Copy Order">
                  <CopyToClipboard
                    onCopy={this.onCopy}
                    text={record.customerdetail}
                  >
                    <Button type="primary" shape="circle" icon="copy" />
                  </CopyToClipboard>
                </Tooltip>
                <Divider type="vertical" />
                <Tooltip title="Edit Order">
                  <Button
                    type="primary"
                    shape="circle"
                    onClick={() => this.editorder(record)}
                    icon="edit"
                  />
                </Tooltip>
                <Divider type="vertical" />
                <Tooltip title="Order Tracking">
                  <Button
                    disabled
                    type="primary"
                    shape="circle"
                    icon="environment"
                  />
                </Tooltip>
                <Divider type="vertical" />
                <Link
                  target="_blank"
                  to={{
                    pathname: "/orderview?id=" + record.key,
                  }}
                >
                  <Tooltip title="View Order ">
                    <Button type="primary" shape="circle" icon="eye" />
                  </Tooltip>
                </Link>
                <Divider type="vertical" />
                <Tooltip title="Revoke Driver">
                  <Button
                    type="primary"
                    shape="circle"
                    onClick={() => this.confirmdelete(record.key)}
                    disabled={
                      record.orderstatus_id === 7 ||
                      record.orderstatus_id === 5 ||
                      record.orderstatus_id === 17 ||
                      record.orderstatus_id === 9
                        ? false
                        : true
                    }
                    icon="user"
                  />
                </Tooltip>
              </span>
            )}
          </span>
        ),
      },
    ];
    return (
      <div>
        <Modal
          title="Order Info"
          visible={this.state.mvisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Form onSubmit={this.handleSubmit1} layout="vertical">
            <Form.Item label="Order Key" className="hidden">
              {getFieldDecorator("order_key", {
                rules: [
                  {
                    required: true,
                    message: "Order key should not empty",
                  },
                ],
              })(<Input disabled />)}
            </Form.Item>
            <Form.Item label="Order Id">
              {getFieldDecorator("order_id", {
                rules: [
                  {
                    required: true,
                    message: "Order Id should not empty",
                  },
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="OTP">
              {getFieldDecorator("otp", {
                rules: [
                  {
                    required: true,
                    message: "OTP should not empty",
                  },
                ],
              })(<Input maxLength={4} />)}
            </Form.Item>
            <Form.Item label="Store">
              {getFieldDecorator("store_id", {
                rules: [
                  {
                    required: true,
                    message: "This field is required",
                  },
                ],
              })(
                <Select
                  style={{
                    width: 340,
                  }}
                  onChange={this.handleStoreID}
                  placeholder="Select Store"
                >
                  {this.renderStorename()}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={this.state.iconLoading}
              >
                Submit
              </Button>
              <Button
                style={{
                  marginLeft: 15,
                }}
                size="large"
                onClick={this.handleCancel}
              >
                Clear
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <div className="container-fluid addp">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <h4>Search Order </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid allproduct">
          <Row className="m-b-30">
            <Col>
              <Form layout="inline" onSubmit={this.handleSubmit}>
                <Row gutter={32}>
                  <Col span={8}>
                    <Form.Item label="Filter By">
                      {getFieldDecorator("filter_by", {
                        initialValue: "Date",
                        rules: [
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ],
                      })(
                        <Select
                          //   mode="multiple"
                          allowClear
                          style={{ width: "320px" }}
                          placeholder="Please select"
                          onChange={this.handlefilterbyOnChange}
                        >
                          <Option value="Date">Date</Option>
                          <Option value="Order_ID">Order ID</Option>
                          <Option value="Phone_Number">Phone Number</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  {this.state.is_date === true ? (
                    <Col span={8}>
                      <Form.Item label="From Date">
                        {getFieldDecorator("start_date", {
                          initialValue: moment(),
                          rules: [
                            {
                              type: "object",
                              required: true,
                              message: "This field is required",
                            },
                          ],
                        })(
                          <DatePicker
                            style={{ width: "320px" }}
                            disabledDate={this.disabledStartDate}
                            format="DD-MM-YYYY"
                            placeholder="Select Date"
                            onChange={this.onStartChange}
                            onOpenChange={this.handleStartOpenChange}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  ) : null}
                  {this.state.is_date === true ? (
                    <Col span={8}>
                      <Form.Item label="To Date">
                        {getFieldDecorator("end_date", {
                          initialValue: moment(),
                          rules: [
                            {
                              type: "object",
                              required: true,
                              message: "This field is required",
                            },
                          ],
                        })(
                          <DatePicker
                            style={{ width: "320px" }}
                            disabledDate={this.disabledEndDate}
                            format="DD-MM-YYYY"
                            placeholder="Select Date"
                            onChange={this.onEndChange}
                            open={endOpen}
                            onOpenChange={this.handleEndOpenChange}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  ) : null}
                  {this.state.is_displayorderid === true ? (
                    <Col span={8}>
                      <Form.Item label="Display Order ID">
                        {getFieldDecorator("display_orderid", {
                          rules: [
                            {
                              type: "string",
                              required: true,
                              message: "This field is required",
                            },
                          ],
                        })(
                          <Input
                            style={{ width: "320px" }}
                            placeholder="Display Order ID"
                          />
                        )}
                      </Form.Item>
                    </Col>
                  ) : null}
                  {this.state.is_phonenumber === true ? (
                    <Col span={8}>
                      <Form.Item label="Phone Number">
                        {getFieldDecorator("phone_number", {
                          rules: [
                            {
                              type: "string",
                              required: true,
                              message: "This field is required",
                            },
                          ],
                        })(
                          <Input
                            style={{ width: "320px" }}
                            placeholder="Phone Number"
                          />
                        )}
                      </Form.Item>
                    </Col>
                  ) : null}
                  <Col span={8}>
                    <Form.Item style={{ marginTop: 40 }}>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                      <Button
                        style={{ marginLeft: 15 }}
                        type="default"
                        onClick={this.handleResett}
                      >
                        Clear
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          <Divider dashed />
          <div className="row m-t-30">
            <div className="text-left filterdiv col-md-6">
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="text-left download-table-xls-button btn ant-btn-primary"
                table="table-to-xls"
                filename="Shopezy-Order-Report"
                sheet="tablexls"
                buttonText="Export Order Report"
              />
            </div>
            <div className="text-right filterdiv col-md-6">
              <span
                style={{
                  marginRight: 10,
                }}
              >
                Last Refreshed Time :
                <TimeAgo date={new Date()}>
                  {({ value }) => (
                    <b>
                      <Icon type="clock-circle" theme="outlined" /> {value}
                    </b>
                  )}
                </TimeAgo>
              </span>
              <Button
                type="primary"
                style={{
                  marginLeft: 15,
                }}
                onClick={this.handleResett}
              >
                Refresh
              </Button>
            </div>
          </div>
          <div>
            <table className="hidden" id="table-to-xls">
              <thead>
                <tr>
                  <th>Customer_ID</th>
                  <th>order_id</th>
                  <th>customer_name</th>
                  <th>customer_phone</th>
                  <th>delivery_address</th>
                  <th>driver_name</th>
                  <th>store_name</th>
                  <th>order_status</th>
                  <th>Total_Price</th>
                  <th>Payment_Type</th>
                  <th>No_Order</th>
                  <th>Order_Coupon_Applicable</th>
                  <th>Order_date</th>
                </tr>
              </thead>
              <tbody>{this.renderNotes()}</tbody>
            </table>
          </div>
          <Table
            columns={columns}
            dataSource={this.state.tdata}
            loading={this.state.loading}
            scroll={{ x: 2500 }}
            size="middle"
            bordered
          />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    order: state.order,
    dashtoday: state.dashtoday,
    common: state.common,
    storeall: state.storeall,
  };
}
const WrappedRegistrationForm = Form.create()(Order);
export default connect(mapStateToProps, {
  emailLogin,
  logout,
  // allstorename,
  getorderdetails,
  // MD_Order_Status,
})(WrappedRegistrationForm);
